<!--
 * @Author: wyj
 * @Date: 2022-04-24 09:54:54
 * @LastEditTime: 2022-04-24 18:18:41
 * @LastEditors: wyj
 * @Description: 
-->
<template>
    <svg :class="svgClass" aria-hidden="true">
      <use :xlink:href="iconName" />
    </svg>
</template>
<script>
export default {
name:'Icon',
   props:{
     iconClass:{
       type:String,
       required:true
     },
     className:{
       type:String,
       default:''
     }
   },
   computed:{
     iconName(){
       return `#icon-${this.iconClass}`
     },
     svgClass(){
       if(this.className){
         return 'svg-icon' +' '+ this.className
       }else{
         return 'svg-icon'
       }
     }
   }
}
</script>
<style scoped>
.svg-icon{
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>